import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Cards.css';

/* 🔹 Spinner Component */
const Spinner = () => (
  <div className="mini-spinner"></div>
);

const OutlineCard = ({ logoSrc, title, value, bgColor, infoText, loading }) => {
  return (
    <div className="outline-card" style={{ backgroundColor: bgColor }}>
      <div className="card-header">
        <img src={logoSrc} alt="Logo" className="logo" />

        <h3>
          {title}
          <span className="info-wrapper">
            <span className="info-icon">i</span>
            <div className="tooltip">{infoText}</div>
          </span>
        </h3>
      </div>

      <div className="card-content">
        <p>
          <strong>
            {loading ? <Spinner /> : value}
          </strong>
        </p>
      </div>
    </div>
  );
};

const formatNumber = (num) => {
  return new Intl.NumberFormat().format(num);
};

const Cards = () => {
  const [cardValues, setCardValues] = useState({
    applications_submitted: '',
    citizen_impacted: '',
    msmes_impacted: '',
    hds_trained: '',
    benefits_unblocked: ''
  });

  const [loading, setLoading] = useState(true); // ✅ NEW

  const fetchData = async () => {
    try {
      setLoading(true); // start loading

      const response = await axios.post(
        "https://api-sales-insights.haqdarshak.com/landing-page-cards"
      );

      const data = response.data;

      setCardValues({
        applications_submitted: formatNumber(data.Total_App_Submitted || 0),
        citizen_impacted: formatNumber(data.DFL_Unique_citizens || 0),
        msmes_impacted: formatNumber(data.Total_Citz_reached || 0),
        hds_trained: formatNumber(data.Num_of_hd_Trained || 0),
        benefits_unblocked:
          formatNumber((data.Total_BV_Received / 10000000).toFixed(2)) +
          " crore"
      });

    } catch (error) {
      console.error("Error fetching API data:", error);
    } finally {
      setLoading(false); // stop loading
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="card-container">

        <OutlineCard
          logoSrc="/Citizen_Impacted.jpg"
          title="DFL Trained Individuals"
          value={cardValues.citizen_impacted}
          loading={loading}
          bgColor="var(--citizen-impacted-color)"
          infoText="Individuals trained on digital and financial literacy since April’23"
        />

        <OutlineCard
          logoSrc="/Application_Submitted.jpg"
          title="Applications Submitted"
          value={cardValues.applications_submitted}
          loading={loading}
          bgColor="var(--applications-submitted-color)"
          infoText='Total number of schemes where the application has reached the "Document Submitted" status.'
        />

        <OutlineCard
          logoSrc="/MSMEs_Impacted.jpg"
          title="Citizens Reached"
          value={cardValues.msmes_impacted}
          loading={loading}
          bgColor="var(--msmes-impacted-color)"
          infoText="Total number of unique citizens reached or screened."
        />

        <OutlineCard
          logoSrc="/HDs_Trained.jpg"
          title="HDs Trained"
          value={cardValues.hds_trained}
          loading={loading}
          bgColor="var(--hds-trained-color)"
          infoText="Total number of HDs trained."
        />

        <OutlineCard
          logoSrc="/Benefits_Unblocked.jpg"
          title="Benefits Unlocked"
          value={cardValues.benefits_unblocked}
          loading={loading}
          bgColor="var(--benefits-unblocked-color)"
          infoText="Total value of benefits unlocked."
        />

      </div>
    </div>
  );
};

export default Cards;